//import { crearDisposicion } from './crearDisposicion';
import { crearBotones } from './crearBotones';
//import { crearCartasPrueba } from './crearCartasPrueba';
import { crearCartelesMano } from './crearCartelesMano';
import { crearDisplays } from './crearDisplays';
import { crearFichasAlfombra } from './crearFichasAlfombra';
import { crearFichasEleccion } from './crearFichasEleccion';
import { crearFlechaMano } from './crearFlechaMano';
import { crearFondo } from './crearFondo';
import { crearMensajesPanel } from './crearMensajesPanel';
import { crearReversoCartaMazo } from './crearReversoCartaMazo';
import { crearReversosAnimados } from './crearReversosAnimados';

/**
 * Carga todos los assets del juego de la ruleta
 * @param {*} scene
 */
export function creacionElementosPrincipal(scene) {
  crearFondo(scene);
  //crearDisposicion(scene);
  crearBotones(scene);
  //crearCartasPrueba(scene); // cartads prueba para testear, luego comentar
  crearCartelesMano(scene);
  crearDisplays(scene);
  crearFichasAlfombra(scene);
  crearFichasEleccion(scene);
  crearFlechaMano(scene);
  crearMensajesPanel(scene);
  crearReversoCartaMazo(scene);
  crearReversosAnimados(scene);
}
